module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/hero-cycle/hero-image-3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/hero-cycle/hero-image-3.jpg
// module id = Yj5E
// module chunks = 0